import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { HpButton, HpCardHeader, HpField } from '@hp/ui';
import { trpc } from '../../api/trpc';
import { ErrorAlert } from '../../components/error-alert';
import { invalidateProjects } from './queries';

/** Quick create with just a name — address & the rest come from the detail page or the website scan. */
export function NewProjectPanel() {
  const { t } = useTranslation(['projects', 'common']);
  const navigate = useNavigate();
  const [name, setName] = useState('');

  const create = useMutation(
    trpc.projects.create.mutationOptions({
      onSuccess: (res) => {
        void invalidateProjects();
        void navigate(`/projects/${res.id}`);
      },
    }),
  );

  return (
    <section className="hp-card">
      <HpCardHeader title={t('new.title')} subtitle={t('new.subtitle')} icon="plus" />
      <div className="hp-card__body bo-sections">
        <form
          className="bo-inline-form"
          onSubmit={(e) => {
            e.preventDefault();
            if (name.trim().length > 0 && !create.isPending) create.mutate({ name: name.trim() });
          }}
        >
          <HpField label={t('new.name')} className="bo-grow">
            <input placeholder={t('new.namePlaceholder')} value={name} onChange={(e) => setName(e.target.value)} />
          </HpField>
          <div className="bo-inline-form__submit">
            <HpButton
              type="submit"
              variant="primary"
              icon="plus"
              busy={create.isPending}
              disabled={name.trim().length === 0}
            >
              {create.isPending ? t('new.creating') : t('new.create')}
            </HpButton>
          </div>
        </form>
        <ErrorAlert error={create.error} />
      </div>
    </section>
  );
}
